import { Box, Button, Text, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import DateField from "components/Atomos/Form/Elements/InputDate";
import { InputText } from "components/Atomos/Form/Elements/InputText";
import { InputTextMask } from "components/Atomos/Form/Elements/InputTextMask";
import CepField from "components/Moleculas/CepField";
import StreetTypeSelect from "components/Moleculas/StreetTypeField";
import { FormComponentProps } from "models/loginForm";
import { RegisterUserFormData, registerUserSchema } from "models/register-user.model";
import { useState } from "react";
import { useForm } from "react-hook-form";
import masks from "utils/masks/masks";

type RegisterFormProps = FormComponentProps<RegisterUserFormData>;

const RegisterForm = ({
    onSuccess,
    onFailed
}: RegisterFormProps) => {
    const { register, control, handleSubmit, setValue, formState: { errors } } = useForm<RegisterUserFormData>({
        resolver: yupResolver(registerUserSchema)
    });

    const [submitting, setSubmitting] = useState(false);
    const handleSubmitClick = async (data: RegisterUserFormData) => {
        try {
            setSubmitting(true);
            await onSuccess(data);
        } catch (err) {
            onFailed?.(err);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <VStack as="form" onSubmit={handleSubmit(handleSubmitClick)} spacing={3}>
            <InputText
                name="fullname"
                label="Nome"
                register={register}
                error={errors?.fullname}
            />
            <InputTextMask
                name="cpf"
                label="CPF"
                mask={masks.BRL_CPF}
                control={control}
                error={errors?.cpf}
            />
            <DateField
                name="birthDate"
                label="Data de nascimento"
                control={control}
                error={errors?.birthDate}
            />
            <InputTextMask
                name="phoneNumber"
                label="Telefone"
                mask={masks.BRL_PHONE}
                control={control}
                error={errors?.phoneNumber}
            />
            <InputText
                name="email"
                label="E-mail"
                register={register}
                error={errors?.email}
            />
            <StreetTypeSelect
                name="streetType"
                label="Tipo de logradouro"
                control={control}
                error={errors?.streetType}
            />
            <CepField
                name="cep"
                label="CEP"
                control={control}
                error={errors?.cep}
                onCepInformationReceive={(location) => {
                    setValue("streetName", location.streetName);
                    setValue("neighborhood", location.neighborhood);
                    setValue("city", location.city);
                    setValue("state", location.state);
                }}
            />
            <InputText
                name="streetName"
                label="Logradouro"
                register={register}
                error={errors?.streetName}
            />
            <InputText
                name="addressNumber"
                label="Número"
                register={register}
                error={errors?.streetName}
            />
            <InputText
                name="addressComplement"
                label="Complemento"
                register={register}
                error={errors?.streetName}
            />
            <InputText
                name="neighborhood"
                label="Bairro"
                register={register}
                error={errors?.streetName}
            />
            <InputText
                name="city"
                label="Município"
                register={register}
                error={errors?.streetName}
            />
            <InputText
                name="state"
                label="UF"
                register={register}
                error={errors?.streetName}
            />
            <Box>
                <InputText
                    type="password"
                    name="password"
                    label="Senha"
                    register={register}
                    error={errors?.password}
                />
                <Text fontSize="xs" color="gray.500">Deve conter 1 letra maiúscula, 1 minúscula, 1 dígito e no mínimo 8 caracteres.</Text>
            </Box>
            <InputText
                type="password"
                name="confirmPassword"
                label="Confirme a senha"
                register={register}
                error={errors?.confirmPassword}
            />

            <Button colorScheme="main" my={3} w="full" isLoading={submitting} type="submit">Cadastrar</Button>
        </VStack>
    )
}
export default RegisterForm